import Vue from 'vue'
import { commaFormat, commaRemove } from '../filter/number'
const getInputTag = (el) => {
  if (el.tagName.toLowerCase() === 'input') {
    return el
  } else {
    return el.querySelector('input')
  }
}

const numberObj = {
  bind(el, bind, vnode) {
    const input = getInputTag(el)
    const eventNames = ['focus', 'blur']

    eventNames.forEach((eventName) => {
      input.addEventListener(eventName, (event) => {
        numberObj.update(event.target)
      })
    })
  },
  update(el, bind, vnode) {
    const input = getInputTag(el)
    setTimeout(() => {
      if (!input.value) {
        return
      }
      const v = commaFormat(commaRemove(input.value))
      input.value = v
    })
  },
}

Vue.directive('input-comma', numberObj)
